
































import { Component, Vue } from 'vue-property-decorator';
import { Data } from './Meta';
import Property from './Property.vue';
import Color from './Color.vue';
import Foreground from './Foreground.vue';
import Background from './Background.vue';

@Component({
  components: {
    Property,
    Color,
    Foreground,
    Background
  }
})
export default class SideMenu extends Vue {
  data = new Data();

  changeTitle(title: string) {
    this.data.title = title;
    this.$emit("change-data", this.data);
  }
  changeDescription(description: string) {
    this.data.description = description;
    this.$emit("change-data", this.data);
  }
  changeSs1(ss1Path: string) {
    this.data.ss1Path = ss1Path;
    this.$emit("change-data", this.data);
  }
  changeSs2(ss2Path: string) {
    this.data.ss2Path = ss2Path;
    this.$emit("change-data", this.data);
  }
  changeIcon(iconPath: string) {
    this.data.iconPath = iconPath;
    this.$emit("change-data", this.data);
  }
  changeColorSet(key: number) {
    this.data.colorSetKey = key;
    this.$emit("change-data", this.data);
  }
  changeForeground(key: number) {
    this.data.foregroundKey = key;
    this.$emit("change-data", this.data);
  }
  changeBackground(key: number) {
    this.data.backgroundKey = key;
    this.$emit("change-data", this.data);
  }
}
